import request from '../utils/request'

const url = 'scenic-spot/'

export function getBackground(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        request({
            url: `${url}basic-info`,
            method: 'get'
        }).then((res) => resolve(res.data)).catch((err) => reject(err))
    })
}

export function getHomeMenu(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        request({
            url: `${url}home-menu`,
            method: 'get'
        }).then((res) => resolve(res.data)).catch((err) => reject(err))
    })
}
